import React, { Component } from 'react'
import styled, { ThemeProvider } from 'styled-components'

import { observer } from 'mobx-react'
import { store } from '../lib/utils'
import { typography, colors, utils } from '../styles'
import HomepageHero from './HomepageHero'
import EpisodeSummary from './EpisodeSummary'
import SignupForm from './SignupForm'
import Cta from './Cta'
import Me from './Me'
import Headline from './Headline'
import Section from './Section'
import P from "./P"
import A from "./A"
import H3 from "./H3"
import { episodes } from '../data'
import Testimonials from './Testimonials'
import Head from './Head'

const Body = styled.div`
  background: white;
  color: black;
`

const SubHeader = styled.div`
  ${colors.lightOnDark}
  letter-spacing: 0.02em;
  padding: 2rem 1rem;
  ${typography.h3.light.center.lh14}
  > *+* {
    margin-top: 1.5rem;
  }
  > p {
    margin-top: 0.5rem;
  }
`

const Container = styled.div`
  ${utils.container}
`

const Homepage = observer(() => (
  <div>
    <Head title="Front End Center — Screencasts for Web Professionals"
          url="https://frontend.center/"
          image="https://frontend.center/front-end-center-logo.png"/>
    <HomepageHero/>
    <Body>
      <SubHeader>
        <h2>Screencasts on the web platform for&nbsp;web&nbsp;professionals.</h2>
        <p>New episodes every month on browsers, performance, tooling&nbsp;&&nbsp;techniques</p>
        <Cta analyticsLabel="top"/>
      </SubHeader>
      <Section>
        <Me/>
      </Section>
      <Section>
        <H3>What people are saying</H3>
        <Testimonials/>
        <Cta analyticsLabel="belowtestimonials"/>
      </Section>
      <H3>Featured Episode</H3>
      <EpisodeSummary ep={episodes.onHomepage.featured} readMore={false} expanded={true}>
        { !store.vimeoIds && <Container>
          <P>
            Watch more <A href="https://www.youtube.com/c/FrontEndCenter" target="_blank">
              free episodes on YouTube
            </A>, then <A href="https://gum.co/frontendcenter" target="_blank">subscribe here</A> to
            get access to the full back catalogue and all new releases!
          </P>
        </Container> }
      </EpisodeSummary>
      <H3>Previous Episodes</H3>
      { episodes.onHomepage.previous.map(ep => <EpisodeSummary key={ep.number} ep={ep} readMore={true}/>) }
      {/*<Section>*/}
        {/*<Headline above="Future Episodes">Coming Soon</Headline>*/}
        {/*<Container>*/}
          {/*<P>*/}
            {/*I've got a huge list of topics to cover, and I work on several episodes at once. Here are some working titles for my upcoming episodes:*/}
          {/*</P>*/}
          {/*<List>*/}
            {/*<li>Managing Global State in React the Easy Way</li>*/}
            {/*<li>Bulletproof SVG Animations</li>*/}
            {/*<li>NPM in 2017—How to Release Code that Everyone Can Use</li>*/}
            {/*<li>Publishing for Contributions—Open Source you can Actually Maintain</li>*/}
          {/*</List>*/}
          {/*<P>*/}
            {/*If you've got feedback on the topics or suggestions for future episodes, you should get in touch*/}
            {/*at <strong>glen@frontend.center</strong>.*/}
          {/*</P>*/}
        {/*</Container>*/}
      {/*</Section>*/}
      <Section>
        <Headline above="">FAQ</Headline>
        <Container>
          <P>
            <strong>Can I download the videos?</strong><br/>
            Yep. All free and paid videos are available as DRM-free downloads to subscribers. Alternatively, you can sync them straight to your dropbox account.
          </P>
          <P>
            <strong>Do you offer discounts for schools or students?</strong><br/>
            Absolutely! Shoot me an email at <A href="mailto:glen@frontend.center">glen@frontend.center</A>, let me know your situation and let's work something out.
          </P>
          <P>
            <strong>Can I sign up on behalf of a team?</strong><br/>
            Please do! My videos are designed to give front-end specialists <strong>and the people they work with</strong> a shared understanding of the underlying web platform, so it's great if they're shared around. <A href="https://gum.co/frontendcenter-teams" target="_blank">Sign up your team here</A> or email me if the current plans aren't quite right for you.
          </P>
        </Container>
      </Section>
      <Section>
        <Cta analyticsLabel="belowfaq"/>
      </Section>
      <Section>
        <Headline above="Not ready to sign up yet?">Subscribe to the free episodes</Headline>
        <Container>
          <P>
            Every couple of months I'll release one of the regular videos for free on Youtube. I'll choose videos that are the most useful for the widest audience. They'll be made to the same standard as subscriber-only
            episodes, <strong>only free</strong>!
            <small>(and less often)</small>
          </P>
          <SignupForm/>
        </Container>
      </Section>
    </Body>
  </div>
))

export default class extends Component {
  constructor() {
    super()
    this.state = {
      animating: window.scrollY < 200
    }
    this.onScroll = this.onScroll.bind(this)
  }

  componentDidMount() {
    document.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.onScroll)
  }

  onScroll() {
    if (window.scrollY > 200) this.setState({ animating: false })
    this.componentWillUnmount()
  }

  render() {
    return <ThemeProvider theme={this.state}>
      <Homepage />
    </ThemeProvider>
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Homepage.js
 **/